import { LineDiagram } from '../../datenauswertung/helper/lineChart';
import * as Moment from 'moment';
import * as React from 'react';

export interface LastgangDiagrammeProps {
    containerSize?: any;
    custom?: any;
    data: any;
    filter?: any;
    id: string;
    isLoaded?: () => void;
    isStatic?: boolean;
    onDone?: (data: any) => void;
}

export interface LastgangDiagrammeState {
    isLoaded: boolean;
}

export class LastgangDiagramme extends React.Component<LastgangDiagrammeProps, LastgangDiagrammeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(): void {
        if (this.props.isStatic && this.props.data) {
            this.init();
        }
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.data !== prevProps.data) {
            this.init();
        }

        if (
            this.props.id !== prevProps.id || JSON.stringify(this.props.filter) !== JSON.stringify(prevProps.filter)
            || (this.props.isStatic && !this.state.isLoaded)
        ) {
            if (!this.props.isStatic) {
                this.setState({ isLoaded: false }, () => this.processLoading());
            } else {
                this.processLoading();
            }
        }
    }

    private dataHoechstleistung: any[] = [];
    private dataLastbereiche: any[] = [];
    private maxDatum: any = null;
    private maxLeistung: number = null;
    private prefix: string = this.props.isStatic ? 'static_' : 'select_';
    private referenceLines: any = {};
    private unitLeistung: any = null;
    private unitVerbrauch: any = null;

    getKeyByUnit(name: string): string {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const powerUnits: any = data.powerUnits || {};
        const keys: string[] = [...Object.keys(energyUnits), ...Object.keys(powerUnits)];
        const units: any = data.units || {};
        let key: string = null;

        Object.keys(units).forEach((index: string) => {
            if (key === null && (units[index] || {}).key === name) {
                key = index;
            }
        });

        if (key === null && keys.indexOf(name) !== -1) {
            Object.keys(((data.data || {}).all || [])[0] || {}).forEach((key2: string) => {
                if (key === null && (key2 || '').toString().endsWith(`-${name}`)) {
                    key = key2;
                }
            });
        }

        return key;
    }

    init(): void {
        this.setUnits();
        const data: any = this.props.data || {};
        const dataJahr: any = [...(data.data || {})['1#y'] || []][0] || {};
        const interval: number = data.interval || null;
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const timestampFrom: number = data.timestampFrom || null;
        const timestampTo: number = data.timestampTo || null;
        // const powerUnits: any = data.powerUnits || {};
        // const unit: string = powerUnits[this.unitLeistung] || null;
        let indexHour: number = 0;
        let lastHour: number = null;
        this.dataHoechstleistung = [];
        this.dataLastbereiche = [];
        this.maxDatum = typeof dataJahr[`${keyLeistung}-max-stamp`] === 'number'
            ? Moment.unix(dataJahr[`${keyLeistung}-max-stamp`] / 1000) : null;
        this.maxLeistung = dataJahr[`${keyLeistung}-max`] || null;
        this.referenceLines.maxLeistung = {
            ifOverflow: 'extendDomain',
            label: {
                value: 'Jahresspitzenlast'/*`Jahresspitzenlast: ${this.maxLeistung}${unit ? ` ${unit}` : ''}`*/, fontWeight: 'bold',
                fill: 'red', position: 'insideBottomRight'
            },
            stroke: 'red',
            y: this.maxLeistung
        };
        const maxDatum: string = this.maxDatum ? Moment(this.maxDatum).format('DD.MM.YYYY') : null;

        [...(data.data || {}).all || []].forEach((item: any) => {
            if (Moment(item.datetime).format('DD.MM.YYYY') === maxDatum) {
                this.dataHoechstleistung.push({ ...item, keyX: Moment(item.datetime).format('HH:mm') });
            };
        });

        [...(data.data || {}).all || []]
            .sort((a: any, b: any) => (+a[keyLeistung] || 0) < (+b[keyLeistung] || 0) ? 1 : -1)
            .forEach((item: any) => {
                if (item.stamp >= timestampFrom && item.stamp <= timestampTo) {
                    const keyX: number = Math.floor(++indexHour * (+interval / 3600));

                    if (keyX === lastHour) {
                        return;
                    }
                    this.dataLastbereiche.push({ ...item, keyX });
                    lastHour = keyX;
                }
            });

        if (this.state.isLoaded) {
            this.setState({ isLoaded: false });
        }

        if (typeof this.props.onDone === 'function') {
            this.onDone();
        }
    }

    onDone(): void {
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const options: any[] = [{ key: 'interval', name: 'Intervall' }];

        if (!keyLeistung) {
            this.props.onDone({ options });
            return;
        }
        // const data: any = this.props.data || {};
        // const timestampFrom: number = data.timestampFrom || null;
        // const timestampTo: number = data.timestampTo || null;
        // options.push({ key: 'lastbereiche', name: 'Lastbereiche' });
        // options.push({ key: 'hoechstleistung', name: 'Höchstleistung' });

        // [...(data.data || {})['1#M'] || []].forEach((item: any) => {
        //     if (item.stamp >= timestampFrom && item.stamp <= timestampTo && typeof (item || {}).datetime !== 'undefined') {
        //         const jahr: number = Moment(item.datetime).year();
        //         const monat: number = Moment(item.datetime).month();
        //         options.push({
        //             key: `monatsleistung-${+Moment([jahr, monat]) / 1000}`,
        //             name: `Lastgang: ${Moment([jahr, monat]).format('MMMM')}`
        //         });
        //     }
        // });
        this.props.onDone({ options });
    }

    async processLoading(): Promise<void> {
        const id: string = `${this.prefix}${this.props.id || ''}`;
        const recharts: NodeListOf<HTMLElement> = await document.querySelectorAll('.recharts-responsive-container');

        for (let index = 0, length: number = recharts.length; index < length; ++index) {
            if (recharts[index].id === id || (!this.state.isLoaded && (index + 1) === length)) {
                this.setState({ isLoaded: true }, () => typeof this.props.isLoaded === 'function' ? this.props.isLoaded() : null);
            }
        }
    }

    reduceData(data: any[], max: number = 730): any[] {
        data = data || [];
        const lastIndex: number = data.length - 1;
        const result: any[] = [];
        const step: number = Math.floor(data.length / max);

        if (data.length <= max) {
            return data;
        }

        data.forEach((item: any, index: number) => {
            if (index % step !== 0 && index !== lastIndex) {
                return;
            }
            result.push(item);
        });

        return result;
    }

    render(): JSX.Element {
        const id: string = this.props.id || '';

        switch (true) {
            case id === 'hoechstleistung':
                return this.renderDiagramHoechstleistung();
            case id.startsWith('interval'):
                return this.renderDiagramIntervall();
            case id === 'lastbereiche':
                return this.renderDiagramLastbereiche();
            case id.startsWith('monatsleistung-'):
                const moment: any = Moment.unix(+(id || '').split('-')[1] || null);
                return moment ? this.renderDiagramMonatsleistung(+moment.format('YYYY'), +moment.format('M')) : null;
            default:
                return null;
        }
    }

    renderDiagramHoechstleistung(): JSX.Element {
        const data: any = this.props.data || {};
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const maxDatum: string = this.maxDatum ? Moment(this.maxDatum).format('DD.MM.YYYY') : null;
        const powerUnits: any = data.powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null;

        if (!keyLeistung) {
            return null;
        }
        const dataDiagram = {
            id: `${this.prefix}hoechstleistung`,
            legendTitle: [`Leistung${unit ? ` [${unit}]` : ''}`],
            lineColor: ['#6351bd'],
            lineWidth: [2],
            visibleData: [keyLeistung]
        };
        const textLines: any[] = [
            {
                value: maxDatum,
                x: 75,
                y: 28,
                style: { fontSize: 12, fontWeight: 'bold' },
                textAnchor: 'start'
            }
        ];

        return (
            <LineDiagram
                data={this.dataHoechstleistung || []}
                visibleData={dataDiagram.visibleData || []}
                id={dataDiagram.id}
                lineColor={dataDiagram.lineColor || []}
                lineWidth={dataDiagram.lineWidth || []}
                textLines={textLines}
                singleYAxis
                legendTitle={dataDiagram.legendTitle || []}
                hideLegend
                unit={[]}
                createNewTick
                lineNoDot
                containerSize={this.props.containerSize ? this.props.containerSize || {} : data.containerSize || {}}
                legendProps={{ wrapperStyle: { position: 'absolute' } }}
                lineChartProps={{ margin: { top: 0, right: 29, bottom: 5, left: 0 }, style: { display: 'inherit' } }}
                X_padding={{ left: 0, right: 0 }}
                X_dataKey='keyX'
                xAxisProps={[{ label: { value: 'Uhrzeit', fontStyle: 'italic', fill: '#555', position: 'insideBottom', offset: -5 } }]}
                yAxisProps={[
                    {
                        width: 60, domain: null, ticks: null,
                        label: { value: unit, fill: '#555', angle: -90, position: 'left', offset: -5 }
                    },
                    { width: 1 }
                ]}
                tooltipLabelPrefix={maxDatum ? `${maxDatum}, ` : null}
            />
        );
    }

    renderDiagramIntervall(): JSX.Element {
        const dataDiagram: any = { ...(this.props.custom || {}), id: `${this.prefix}${this.props.id || 'interval'}` };
        const referenceLines: any[] = Array.isArray(dataDiagram.referenceLines)
            ? dataDiagram.referenceLines
            : [this.referenceLines.maxLeistung || null];

        return (
            <LineDiagram
                data={dataDiagram.data || []}
                visibleData={dataDiagram.visibleData || []}
                id={dataDiagram.id}
                lineColor={dataDiagram.lineColor || []}
                lineWidth={dataDiagram.lineWidth || []}
                referenceLines={referenceLines}
                singleYAxis
                legendTitle={dataDiagram.legendTitle || []}
                unit={dataDiagram.unit || []}
                createNewTick
                lineNoDot
                containerSize={this.props.containerSize ? this.props.containerSize || {} : dataDiagram.containerSize || {}}
                legendProps={{ wrapperStyle: { position: 'absolute' } }}
                lineChartProps={{ margin: { top: 5, right: 29, bottom: 0, left: 0 }, style: { display: 'inherit' } }}
                X_padding={{ left: 0, right: 0 }}
                X_dataKey='keyX'
                yAxisProps={[{ width: 60, domain: null, ticks: null }, { width: 1 }]}
            />
        );
    }

    renderDiagramLastbereiche(): JSX.Element {
        const data: any = this.props.data || {};
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const powerUnits: any = data.powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null;

        if (!keyLeistung) {
            return null;
        }
        const dataDiagram = {
            id: `${this.prefix}lastbereiche`,
            legendTitle: [`Leistung${unit ? ` [${unit}]` : ''}`],
            lineColor: ['#6351bd'],
            lineWidth: [2],
            visibleData: [keyLeistung]
        };

        return (
            <LineDiagram
                data={this.reduceData(this.dataLastbereiche || [])}
                visibleData={dataDiagram.visibleData || []}
                id={dataDiagram.id}
                lineColor={dataDiagram.lineColor || []}
                lineWidth={dataDiagram.lineWidth || []}
                singleYAxis
                legendTitle={dataDiagram.legendTitle || []}
                hideLegend
                unit={[]}
                createNewTick
                lineNoDot
                containerSize={this.props.containerSize ? this.props.containerSize || {} : data.containerSize || {}}
                legendProps={{ wrapperStyle: { position: 'absolute' } }}
                lineChartProps={{ margin: { top: 0, right: 29, bottom: 5, left: 0 }, style: { display: 'inherit' } }}
                X_padding={{ left: 0, right: 0 }}
                X_dataKey='keyX'
                xAxisProps={[{ label: { value: 'Stunden', fontStyle: 'italic', fill: '#555', position: 'insideBottom', offset: -5 } }]}
                yAxisProps={[
                    {
                        width: 60, domain: null, ticks: null,
                        label: { value: unit, fill: '#555', angle: -90, position: 'left', offset: -5 }
                    },
                    { width: 1 }
                ]}
                tooltipLabelSuffix=' h'
            />
        );
    }

    renderDiagramMonatsleistung(jahr: number, monat: number): JSX.Element {
        const data: any = this.props.data || {};
        const dataMonate: any[] = [];
        const key: string = `${jahr}-${monat}`;
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const powerUnits: any = data.powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null
        const weekdays: number[] = Array.isArray((this.props.filter || {}).weekdays) ? this.props.filter.weekdays : [];

        if (!keyLeistung || !jahr || !monat) {
            return null;
        }
        const dataDiagram = {
            id: `${this.prefix}monatsleistung-${+Moment([jahr, monat - 1]) / 1000}`,
            legendTitle: [`Leistung${unit ? ` [${unit}]` : ''}`],
            lineColor: ['#6351bd'],
            lineWidth: [1],
            unit: [unit, unit],
            visibleData: [keyLeistung]
        };
        const textLines: any[] = [{
            value: `${Moment([jahr, monat - 1]).format('MMMM')}: Leistung${unit ? ` [${unit}]` : ''}`,
            x: '50%',
            y: 0,
            dy: 11,
            style: { fontSize: 12, fontWeight: 'bold' },
            textAnchor: 'middle'
        }];

        [...(data.data || {}).all || []].forEach((item: any) => {
            const moment: any = Moment(item.datetime);

            if (moment.format('YYYY-M') === key && (weekdays.length ? weekdays.indexOf(moment.isoWeekday()) !== -1 : true)) {
                dataMonate.push({ ...item, keyX: moment.format('DD.MM.') });
            };
        });

        return (
            <LineDiagram
                data={dataMonate}
                visibleData={dataDiagram.visibleData || []}
                id={dataDiagram.id}
                lineColor={dataDiagram.lineColor || []}
                lineWidth={dataDiagram.lineWidth || []}
                referenceLines={[this.referenceLines.maxLeistung || null]}
                textLines={textLines}
                singleYAxis
                legendTitle={dataDiagram.legendTitle || []}
                hideLegend
                unit={[]}
                createNewTick
                lineNoDot
                containerSize={this.props.containerSize ? this.props.containerSize || {} : data.containerSize || {}}
                legendProps={{ wrapperStyle: { position: 'absolute' } }}
                lineChartProps={{ margin: { top: 20, right: 29, bottom: 0, left: 0 }, style: { display: 'inherit' } }}
                X_padding={{ left: 0, right: 0 }}
                X_dataKey='keyX'
                yAxisProps={[{ width: 60, domain: null, ticks: null }, { width: 1 }]}
                tooltipLabelSuffix={jahr.toString()}
            />
        );
    }

    setUnits(): void {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const energyKeys: string[] = Object.keys(energyUnits);
        const powerUnits: any = data.powerUnits || {};
        const powerKeys: string[] = Object.keys(powerUnits);
        const units: any = data.units || {};

        Object.keys(units).forEach((index: string) => {
            if (this.unitLeistung === null && powerKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitLeistung = units[index].key;
                this.unitVerbrauch = energyUnits[`${this.unitLeistung}h`] ? `${this.unitLeistung}h` : null;
            }

            if (this.unitVerbrauch === null && energyKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitVerbrauch = units[index].key;
                const keyEnergy: string = this.unitVerbrauch.substr(0, this.unitVerbrauch.length - 1);
                this.unitLeistung = powerUnits[keyEnergy] ? keyEnergy : null;
            }
        });
    }
}
